module.exports = __webpack_public_path__ + "img/geocities.png.19c2a86b.webp";